module.exports = __webpack_public_path__ + "static/media/Richard Bao.10a51cfa.png";